var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0--al-err)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.721 3.81344L2.42767 22.6668C2.19483 23.07 2.07163 23.5272 2.07032 23.9928C2.06902 24.4584 2.18966 24.9163 2.42024 25.3208C2.65082 25.7253 2.98331 26.0624 3.38461 26.2986C3.78592 26.5347 4.24207 26.6617 4.70767 26.6668H27.2943C27.7599 26.6617 28.2161 26.5347 28.6174 26.2986C29.0187 26.0624 29.3512 25.7253 29.5818 25.3208C29.8123 24.9163 29.933 24.4584 29.9317 23.9928C29.9304 23.5272 29.8072 23.07 29.5743 22.6668L18.281 3.81344C18.0433 3.42159 17.7086 3.0976 17.3093 2.87276C16.9099 2.64791 16.4593 2.52979 16.001 2.52979C15.5427 2.52979 15.0921 2.64791 14.6927 2.87276C14.2934 3.0976 13.9587 3.42159 13.721 3.81344V3.81344Z",
    stroke: "#FFA71E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3335H16.0133",
    stroke: "#FFA71E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6665V15.9998",
    stroke: "#FFA71E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0--al-err"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alertError.197f3025.svg";
export { ForwardRef as ReactComponent };